import gql from "graphql-tag"
import CelebrationTag from "../fragments/CelebrationTag"

const query = gql`
  query CelebrationTags($kind: CelebrationTagKind!) {
    celebrationTags(kind: $kind) {
      ...CelebrationTag
    }
  }
  ${CelebrationTag}
`

export default query
